export default __webpack_public_path__ + "static/BC Certified logo_ISO 27017-2015_ENG-1a5b636a73ae42a98e4b69f72b75e8b2.png";